import type { ReactNode } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import Animated, { useAnimatedRef, useScrollViewOffset } from 'react-native-reanimated';
import { ScrollContext } from './ScrollContext';

interface ParallaxScrollViewProps {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
  contentContainerStyle?: StyleProp<ViewStyle>;
}

/**
 * Drop-in replacement for the landing ScrollView that publishes the live scroll
 * offset (UI thread) to descendants via ScrollContext, enabling parallax and
 * scroll-reveal animations.
 */
export const ParallaxScrollView = ({
  children,
  style,
  contentContainerStyle,
}: ParallaxScrollViewProps) => {
  const animatedRef = useAnimatedRef<Animated.ScrollView>();
  const offset = useScrollViewOffset(animatedRef);

  return (
    <ScrollContext.Provider value={{ offset }}>
      <Animated.ScrollView
        ref={animatedRef}
        style={style}
        contentContainerStyle={contentContainerStyle}
        scrollEventThrottle={16}
        showsVerticalScrollIndicator={false}
      >
        {children}
      </Animated.ScrollView>
    </ScrollContext.Provider>
  );
};
